<template>
  <VContainer fluid class="pa-0 ma-0" style="background: #DFDFDD;">
    <!-- DESKTOP -->
    <VContainer fluid class="d-none d-lg-block py-16 ma-0 pa-0 linear-background transparent" id="advantage-description">
      <VContainer fluid>
        <VRow class="justify-center ma-0 pa-0">
          <VCol cols="12">
            <!-- Bloco único com cantos arredondados -->
            <VCard class="frost elevation-10 px-10 py-4 rounded-xl">
              <VRow class="ma-0">
                <VCol cols="12" md="2" class="text-center">
                  <VCard variant="text">
                    <VCardText class="text-center">
                      <VIcon color="secondary" class="mt-2" size="x-large">mdi-network-pos</VIcon>
                    </VCardText>
                    <VCardText class="text-center mt-n8 text-secondary text-h6">
                      {{ $t('PRESENTATION.budget') }}
                    </VCardText>
                  </VCard>
                </VCol>

                <VCol cols="12" md="2" class="text-center">
                  <VCard variant="text">
                    <VCardText class="text-center">
                      <VIcon color="secondary" class="mt-2" size="x-large">mdi-developer-board</VIcon>
                    </VCardText>
                    <VCardText class="text-center mt-n8 text-secondary text-h6">
                      {{ $t('PRESENTATION.production') }}
                    </VCardText>
                  </VCard>
                </VCol>

                <VCol cols="12" md="2" class="text-center">
                  <VCard variant="text">
                    <VCardText class="text-center">
                      <VIcon color="secondary" class="mt-2" size="x-large">mdi-invoice-list-outline</VIcon>
                    </VCardText>
                    <VCardText class="text-center mt-n8 text-secondary text-h6">
                      {{ $t('PRESENTATION.invoice') }}
                    </VCardText>
                  </VCard>
                </VCol>

                <VCol cols="12" md="2" class="text-center">
                  <VCard variant="text">
                    <VCardText class="text-center">
                      <VIcon color="secondary" class="mt-2" size="x-large">mdi-material-design</VIcon>
                    </VCardText>
                    <VCardText class="text-center mt-n8 text-secondary text-h6">
                      {{ $t('PRESENTATION.materials') }}
                    </VCardText>
                  </VCard>
                </VCol>

                <VCol cols="12" md="2" class="text-center">
                  <VCard variant="text">
                    <VCardText class="text-center">
                      <VIcon color="secondary" class="mt-2" size="x-large">mdi-account-group</VIcon>
                    </VCardText>
                    <VCardText class="text-center mt-n8 text-secondary text-h6">
                      {{ $t('PRESENTATION.resources') }}
                    </VCardText>
                  </VCard>
                </VCol>

                <VCol cols="12" md="2" class="text-center">
                  <VCard variant="text">
                    <VCardText class="text-center">
                      <VIcon color="secondary" class="mt-2" size="x-large">mdi-trending-down</VIcon>
                    </VCardText>
                    <VCardText class="text-center mt-n8 text-secondary text-h6">
                      {{ $t('PRESENTATION.costs') }}
                    </VCardText>
                  </VCard>
                </VCol>
              </VRow>
            </VCard>
          </VCol>
        </VRow>

      </VContainer>

      <VRow class="justify-center ma-2 pa-4" style="margin-top: -80px !important;">
        <VCol cols="12" md="2">
          <VCard class="rounded-pill mx-2 elevation-10" height="100" style="background-color: rgba(61, 74, 109, 0.9);">
            <VCardText class="text-center text-white font-weight-bold text-h6" style="position: relative; top: 50%; transform: translate(0, -50%);">
              {{ $t('PRESENTATION.login') }}
            </VCardText>
          </VCard>
        </VCol>
        <VCol cols="12" md="2">
          <VCard class="rounded-pill mx-2 elevation-10" height="100" style="background-color: rgba(61, 74, 109, 0.9);">
            <VCardText class="text-center text-white font-weight-bold text-h6" style="position: relative; top: 50%; transform: translate(0, -50%);">
              {{ $t('PRESENTATION.dashboard') }}
            </VCardText>
          </VCard>
        </VCol>
      </VRow>

      <VRow class="justify-center ma-2 pa-4">
        <VCol cols="12" md="2">
          <VCard class="rounded-pill mx-2 elevation-10" height="100" style="background-color: rgba(61, 74, 109, 0.9);">
            <VCardText class="text-center text-white font-weight-bold text-h6" style="position: relative; top: 50%; transform: translate(0, -50%);">
              {{ $t('PRESENTATION.development') }}
            </VCardText>
          </VCard>
        </VCol>
        <VCol cols="12" md="2">
          <VCard class="rounded-pill mx-2 elevation-10" height="100" style="background-color: rgba(61, 74, 109, 0.9);">
            <VCardText class="text-center text-white font-weight-bold text-h6" style="position: relative; top: 50%; transform: translate(0, -50%);">
              {{ $t('PRESENTATION.export') }}
            </VCardText>
          </VCard>
        </VCol>
      </VRow>

      <VRow class="justify-center ma-2 pa-4">
        <VCol cols="12" md="2">
          <VCard class="rounded-pill mx-2 elevation-10" height="100" style="background-color: rgba(61, 74, 109, 0.9);">
            <VCardText class="text-center text-white font-weight-bold text-h6" style="position: relative; top: 50%; transform: translate(0, -50%);">
              {{ $t('PRESENTATION.secure') }}
            </VCardText>
          </VCard>
        </VCol>
        <VCol cols="12" md="2">
          <VCard class="rounded-pill mx-2 elevation-10" height="100" style="background-color: rgba(61, 74, 109, 0.9);">
            <VCardText class="text-center text-white font-weight-bold text-h6" style="position: relative; top: 50%; transform: translate(0, -50%);">
              {{ $t('PRESENTATION.notifications') }}
            </VCardText>
          </VCard>
        </VCol>
      </VRow>

      <VRow class="justify-center ma-2 pa-4">
        <VCol cols="12" md="2">
          <VCard class="elevation-10 ma-2 rounded-xl" height="100%" style="background-color: rgba(255, 255, 255, 0.9);">
            <VCardText class="text-center">
              <span class="text-h6">{{ $t('PRESENTATION.simple.title') }}</span>
            </VCardText>
            <VCardText class="text-justify text-body-1 font-weight-bold">
              {{ $t('PRESENTATION.simple.text') }}
            </VCardText>
          </VCard>
        </VCol>

        <VCol cols="12" md="2">
          <VCard class="elevation-10 ma-2 rounded-xl" height="100%" style="background-color: rgba(255, 255, 255, 0.9);">
            <VCardText class="text-center">
              <span class="text-h6">{{ $t('PRESENTATION.dynamic.title') }}</span>
            </VCardText>
            <VCardText class="text-justify text-body-1 font-weight-bold">
              {{ $t('PRESENTATION.dynamic.text') }}
            </VCardText>
          </VCard>
        </VCol>

        <VCol cols="12" md="2">
          <VCard class="elevation-10 ma-2 rounded-xl" height="100%" style="background-color: rgba(255, 255, 255, 0.9);">
            <VCardText class="text-center">
              <span class="text-h6">{{ $t('PRESENTATION.secure_box.title') }}</span>
            </VCardText>
            <VCardText class="text-justify text-body-1 font-weight-bold">
              {{ $t('PRESENTATION.secure_box.text') }}
            </VCardText>
          </VCard>
        </VCol>
      </VRow>
    </VContainer>

    <!-- MOBILE -->
    <VContainer fluid class="d-md-none py-16 ma-0 pa-0 transparent" id="advantage-description">
      <VContainer fluid>
        <VRow class="justify-center ma-0 pa-0">
          <VCol cols="12" class="py-4">
            <VCard width="50%" height="150" class="elevation-10 rounded-xl" style="background-color: rgba(255, 255, 255, 0.9); margin: auto; display: block;">
              <VCardText class="text-center">
                <VIcon color="secondary" class="mt-4" size="x-large">mdi-network-pos</VIcon>
              </VCardText>
              <VCardText class="text-center mt-n8 text-secondary text-h6">
                {{ $t('PRESENTATION.budget') }}
              </VCardText>
            </VCard>
          </VCol>

          <VCol cols="12" class="py-4">
            <VCard width="50%" height="150" class="elevation-10 rounded-xl" style="background-color: rgba(255, 255, 255, 0.9); margin: auto; display: block;">
              <VCardText class="text-center">
                <VIcon color="secondary" class="mt-4" size="x-large">mdi-developer-board</VIcon>
              </VCardText>
              <VCardText class="text-center mt-n8 text-secondary text-h6">
                {{ $t('PRESENTATION.production') }}
              </VCardText>
            </VCard>
          </VCol>

          <VCol cols="12" class="py-4">
            <VCard width="50%" height="150" class="elevation-10 rounded-xl" style="background-color: rgba(255, 255, 255, 0.9); margin: auto; display: block;">
              <VCardText class="text-center">
                <VIcon color="secondary" class="mt-4" size="x-large">mdi-invoice-list-outline</VIcon>
              </VCardText>
              <VCardText class="text-center mt-n8 text-secondary text-h6">
                {{ $t('PRESENTATION.invoice') }}
              </VCardText>
            </VCard>
          </VCol>

          <VCol cols="12" class="py-4">
            <VCard width="50%" height="150" class="elevation-10 rounded-xl" style="background-color: rgba(255, 255, 255, 0.9); margin: auto; display: block;">
              <VCardText class="text-center">
                <VIcon color="secondary" class="mt-4" size="x-large">mdi-material-design</VIcon>
              </VCardText>
              <VCardText class="text-center mt-n8 text-secondary text-h6">
                {{ $t('PRESENTATION.materials') }}
              </VCardText>
            </VCard>
          </VCol>

          <VCol cols="12" class="py-4">
            <VCard width="50%" height="150" class="elevation-10 rounded-xl" style="background-color: rgba(255, 255, 255, 0.9); margin: auto; display: block;">
              <VCardText class="text-center">
                <VIcon color="secondary" class="mt-4" size="x-large">mdi-account-group</VIcon>
              </VCardText>
              <VCardText class="text-center mt-n8 text-secondary text-h6">
                {{ $t('PRESENTATION.resources') }}
              </VCardText>
            </VCard>
          </VCol>

          <VCol cols="12" class="py-4">
            <VCard width="50%" height="150" class="elevation-10 rounded-xl" style="background-color: rgba(255, 255, 255, 0.9); margin: auto; display: block;">
              <VCardText class="text-center">
                <VIcon color="secondary" class="mt-4" size="x-large">mdi-trending-down</VIcon>
              </VCardText>
              <VCardText class="text-center mt-n8 text-secondary text-h6">
                {{ $t('PRESENTATION.costs') }}
              </VCardText>
            </VCard>
          </VCol>
        </VRow>
      </VContainer>

      <VRow class="justify-center ma-2 pa-4">
        <VCol cols="12" class="py-4">
          <VCard class="rounded-pill elevation-10" height="100" width="65%" style="margin: auto; display: block; background-color: rgba(61, 74, 109, 0.9);">
            <VCardText class="text-center text-white font-weight-bold text-body-1" style="position: relative; top: 50%; transform: translate(0, -50%);">
              {{ $t('PRESENTATION.login') }}
            </VCardText>
          </VCard>
        </VCol>

        <VCol cols="12" class="py-4">
          <VCard class="rounded-pill elevation-10" height="100" width="65%" style="margin: auto; display: block; background-color: rgba(61, 74, 109, 0.9);">
            <VCardText class="text-center text-white font-weight-bold text-body-1" style="position: relative; top: 50%; transform: translate(0, -50%);">
              {{ $t('PRESENTATION.dashboard') }}
            </VCardText>
          </VCard>
        </VCol>

        <VCol cols="12" class="py-4">
          <VCard class="rounded-pill elevation-10" height="100" width="65%" style="margin: auto; display: block; background-color: rgba(61, 74, 109, 0.9);">
            <VCardText class="text-center text-white font-weight-bold text-body-1" style="position: relative; top: 50%; transform: translate(0, -50%);">
              {{ $t('PRESENTATION.development') }}
            </VCardText>
          </VCard>
        </VCol>

        <VCol cols="12" class="py-4">
          <VCard class="rounded-pill elevation-10" height="100" width="65%" style="margin: auto; display: block; background-color: rgba(61, 74, 109, 0.9);">
            <VCardText class="text-center text-white font-weight-bold text-body-1" style="position: relative; top: 50%; transform: translate(0, -50%);">
              {{ $t('PRESENTATION.export') }}
            </VCardText>
          </VCard>
        </VCol>

        <VCol cols="12" class="py-4">
          <VCard class="rounded-pill elevation-10" height="100" width="65%" style="margin: auto; display: block; background-color: rgba(61, 74, 109, 0.9);">
            <VCardText class="text-center text-white font-weight-bold text-body-1" style="position: relative; top: 50%; transform: translate(0, -50%);">
              {{ $t('PRESENTATION.secure') }}
            </VCardText>
          </VCard>
        </VCol>

        <VCol cols="12" class="py-4">
          <VCard class="rounded-pill elevation-10" height="100" width="65%" style="margin: auto; display: block; background-color: rgba(61, 74, 109, 0.9);">
            <VCardText class="text-center text-white font-weight-bold text-body-1" style="position: relative; top: 50%; transform: translate(0, -50%);">
              {{ $t('PRESENTATION.notifications') }}
            </VCardText>
          </VCard>
        </VCol>
      </VRow>

      <VRow class="justify-center ma-2 pa-4">
        <VCol cols="12" class="py-4">
          <VCard width="50%" class="elevation-16 rounded-xl" height="100%" style="margin: auto; display: block; background-color: rgba(255, 255, 255, 0.9);">
            <VCardText class="text-center">
              <span class="text-h6 font-weight-bold">{{ $t('PRESENTATION.simple.title') }}</span>
            </VCardText>
            <VDivider />
            <VCardText class="text-body-1 font-weight-light">
              {{ $t('PRESENTATION.simple.text') }}
            </VCardText>
          </VCard>
        </VCol>

        <VCol cols="12" class="py-4">
          <VCard width="50%" class="elevation-16 rounded-xl" height="100%" style="margin: auto; display: block; background-color: rgba(255, 255, 255, 0.9);">
            <VCardText class="text-center">
              <span class="text-h6 font-weight-bold">{{ $t('PRESENTATION.dynamic.title') }}</span>
            </VCardText>
            <VDivider />
            <VCardText class="text-body-1 font-weight-light">
              {{ $t('PRESENTATION.dynamic.text') }}
            </VCardText>
          </VCard>
        </VCol>

        <VCol cols="12" class="py-4">
          <VCard width="50%" class="elevation-16 rounded-xl" height="100%" style="margin: auto; display: block; background-color: rgba(255, 255, 255, 0.9);">
            <VCardText class="text-center">
              <span class="text-h6 font-weight-bold">{{ $t('PRESENTATION.secure_box.title') }}</span>
            </VCardText>
            <VDivider />
            <VCardText class="text-body-1 font-weight-light">
              {{ $t('PRESENTATION.secure_box.text') }}
            </VCardText>
          </VCard>
        </VCol>
      </VRow>
    </VContainer>
  </VContainer>
</template>

<style>
body #advantage-description{
  background: rgb(255, 255, 255) url("../assets/imgs/3.jpeg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.frost{
  background-color: rgba(255,255,255,0.70); /* fundo branco translúcido */
  border-radius: 24px;                      /* cantos arredondados visíveis */
}
/* opcional: dá um efeito vidro suave (se quiseres) */
.frost{
  backdrop-filter: saturate(120%) blur(2px);
}
</style>
